import { Grid, SegmentedControl, Text, Tooltip } from '@mantine/core';
import { IconQuestionMark } from '@tabler/icons-react';
import LabeledSlider from './LabeledSlider';

const DailyLimitSettings = ({
  model,
  onChange,
  channelLabel,
  maxPerDay,
  accountId,
  domainId,
  settingsTab,
  disableReschedule,
  disableSendAnyway,
}) => {
  return (
    <>
      {model.onDailyLimitReached === 'reschedule' && !disableReschedule ? (
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 2 }}>
            <Text size="sm" fw={500}>
              Max Reschedules
              <Tooltip
                label={`There is a limit on the number of ${channelLabel} a user may receive per day. If the limit is reached for a given user, we retry on the following day. This controls how many attempts are to be made before giving up trying to send to this particular user.`}
                position="top"
              >
                <IconQuestionMark size={12} />
              </Tooltip>
            </Text>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 10 }}>
            <LabeledSlider
              min={1}
              max={10}
              value={model.maxReschedules}
              onChange={(maxReschedules) => onChange('maxReschedules', maxReschedules)}
            />
          </Grid.Col>
        </Grid>
      ) : null}
      <Grid mt="md">
        <Grid.Col span={{ base: 12, sm: 2 }}>
          <Text size="sm" fw={500}>
            If max {channelLabel} per day is reached
          </Text>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 10 }}>
          <SegmentedControl
            value={model.onDailyLimitReached ?? ''}
            onChange={(value) => {
              onChange('onDailyLimitReached', value);
            }}
            data={[
              ...(disableReschedule ? [] : [{ label: 'Reschedule', value: 'reschedule' }]),
              ...(disableSendAnyway ? [] : [{ label: 'Send anyway', value: 'send' }]),
              { label: 'Skip sending', value: 'skip' },
            ]}
          />
          <Text size="sm" c="dimmed">
            This controls what happens if a user has already received the maximum allowed {channelLabel} per day (
            {maxPerDay}).
            <br />
            {!disableReschedule && (
              <>
                When set to <strong>Reschedule</strong>, the message to this user will be rescheduled for the next
                allowed time slot that is at least 24 hours in the future.
                <br />
              </>
            )}
            {!disableSendAnyway && (
              <>
                When set to <strong>Send anyway</strong>, the limit above will be ignored and the message to this user
                will be sent without delay.
                <br />
              </>
            )}
            When set to <strong>Skip sending</strong>, the message to this user will not be sent.
            <br />
            <br />
            The number of allowed {channelLabel} per day can be adjusted from the
            <a
              href={`#/accounts/${accountId}/domains/${domainId}/settings/messagingAndAds?tab=${settingsTab}`}
              target="_blank"
              rel="noreferrer"
            >
              {' '}
              shop settings page.
            </a>
            <strong>
              {' '}
              Note that this setting only applies when this message is used in continuous campaigns or workflows. For
              all other uses, this message will be sent regardless of the limit.
            </strong>
            .
          </Text>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default DailyLimitSettings;
